import { render, staticRenderFns } from "./ViewDataPostApprove.vue?vue&type=template&id=e7c5c8ac"
import script from "./ViewDataPostApprove.vue?vue&type=script&lang=js"
export * from "./ViewDataPostApprove.vue?vue&type=script&lang=js"
import style0 from "./ViewDataPostApprove.vue?vue&type=style&index=0&id=e7c5c8ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports